<template>
  <div class="sdiv cpointer bborder" @click="goDetail">
    <div class="fs18" v-html="title"></div>
    <div class="tc9 lh18 mt15 int ofhidden" v-html="msg">
    </div>

    <div class="tc-red mt10">
      <span>日期：{{item.created_at}} </span>
      <span>来源：{{item.source}}  </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchItem",
  data(){
    return {
      title:'',
      msg:'',
      url:'',
      tourl:'',
    }
  },
  props:[
    'item',
    'keyword',
  ],
  methods:{
    dealMsg(){
      if(this.msg == '' || this.msg == null){
        this.msg = '';
      }
      this.msg = this.msg.replace(/<.*?>/ig, "");
      this.msg = this.msg.replace(/<\/.*?>/ig, "");
      this.msg = this.msg.replace(/(\&.*?;)/ig, "");
      var index_ = this.msg.indexOf(this.keyword);
      if(index_ > 0){
        var newStr =  this.msg.substr(0,index_);
        var lastD = newStr.lastIndexOf('，');
        var lastJ = newStr.lastIndexOf('。');
        var last = (lastD>lastJ)?lastD:lastJ;
        if(last > 0){
          this.msg = this.msg.substr(last+1,this.msg.length);
        }
      }
      this.msg = this.msg.replace(new RegExp(this.keyword, 'ig'), "<span style=\"color:red\">"+this.keyword+"</span>");
      this.title = this.title.replace(new RegExp(this.keyword, 'ig'), "<span style=\"color:red\">"+this.keyword+"</span>");
    },
    goDetail (){
      this.$router.push('/evn/detail?article_id='+this.item.id);
    }
  },
  mounted() {

  },
  updated() {
  },
  watch:{
    keyword:{
      immediate:true,
      handler:function(n,o){
        this.title = this.item.title;
        this.msg = this.item.content;
        this.dealMsg();
      }
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/search/SearchItem.vue